<template>
  <div :key="refresh_key">
    <!-- *** IME **** -->
    <form-input
      label="Ime"
      id="ime"
      ref="imeFiz"
      required="required"
      :base="pravnoTijelo.ime"
      :invalid="invalid_elements.ime"
    ></form-input>
    <!-- *** Prezime **** -->
    <form-input
      label="Prezime"
      id="prezime"
      ref="prezimeFiz"
      required="required"
      :base="pravnoTijelo.prezime"
      :invalid="invalid_elements.prezime"
    ></form-input>
    <!-- OIB -->
    <!-- <form-input label="OIB" id="oib" ref="OIB" required="required"  :base="pravnoTijelo.oib"></form-input> -->
    <!-- single autocomplete za nadlezno tijelo -->

    <!-- *** Email *** -->
    <form-input-multiple :base="pravnoTijelo.email_list" ref="email" :name="'email'" :label="'Email'" :placeholder="'Unesite novu email adresu'" />
    <!-- *** Broj telefona *** -->
    <form-input-multiple :base="pravnoTijelo.tel_br_list" ref="telefon" :name="'telefon'" :label="'Broj telefona'" :placeholder="'Unesite novi broj telefona'" />
    <!-- *** Web stranica *** -->
    <form-input-multiple :base="pravnoTijelo.web_list" ref="stranica" :name="'stranica'" :label="'Web stranica'" :placeholder="'Unesite novu web stranicu'" />

    
  <div class="form-divider"></div>
    <adresa-element ref="adresaElement" :base="pravnoTijelo.adrese_list" />
    <div class="form-divider"></div>
    <form-autocomplete-single
      :name="'nadleznaInst'"
      :placeholder="'Unesite nadležnu instituciju'"
      :type="'Institucija'"
      :label="'Nadležna institucija'"
      :id="'institucija'"
      ref="nadleznaInst"
      :items="institucije"
    ></form-autocomplete-single>
    <!-- *** Drugi kontakt ****
    <form-input
      label="Drugi kontakt"
      id="drugi-kontakt"
      ref="drugiKontakt"
    ></form-input> -->
    <!-- *** Radno vrijeme **** -->
    <form-input
      label="Radno vrijeme"
      id="radno-vrijeme"
      ref="radnoVrijeme"
      :base="pravnoTijelo.radno_vrijeme"
    ></form-input>
    <!-- *** OPIS **** -->
    <form-textarea label="Opis" id="opis" ref="opis" :base="pravnoTijelo.opis"></form-textarea>
  </div>
</template>

<script>
import formInput from "@/components/formElements/formInput.vue";
import formTextarea from "@/components/formElements/formTextarea.vue";
import formDropDown from "@/components/formElements/formDropDown.vue";
import formAutocomplete from "@/components/formElements/formInputAutocomplete.vue";
import adresaElement from "@/components/formElements/adresaElement.vue";
import formInputMultiple from '@/components/formElements/formInputMultiple.vue'
import formAutocompleteSingle from "@/components/formElements/formAutocompleteSingle.vue";
import osobe from "@/apiCallers/promise_handler_db/osobe_pr";


export default {
  data() {
    return {
      refresh_key: 1,
      pravnoTijelo: {
        ime: "",
        prezime: "",
        email_list: [],
        tel_br_list: [],
        adrese_list: [],
        web_list: [],
        radno_vrijeme: "",
        opis: "",
        institucija: "",
      },
    };
  },
  async created() {
    let route_name = this.$router.history.current.name;
    if (route_name === "LegalBodyEdit") {
      console.log(this.$router.history.current.params.oib);
      //legalbody dohvacanje
      await osobe
        .get_single_legal_body(this.$router.history.current.params.oib)
        .then(async (resp) => {
          console.log("OSOBA:")
          console.log(resp.data)
          const prav_tij_entry =resp.data;
          
          this.$refs.imeFiz.$data.value = prav_tij_entry.ime == null ? '':prav_tij_entry.ime;
          this.$refs.prezimeFiz.$data.value = prav_tij_entry.prezime == null ? '':prav_tij_entry.prezime

          this.$refs.adresaElement.$data.lista_adresa = prav_tij_entry.adresa == null ? [] : prav_tij_entry.adresa;

          this.$refs.email.$data.values = prav_tij_entry.email_list
          this.$refs.telefon.$data.values = prav_tij_entry.tel_br_list;
          this.$refs.stranica.$data.values = prav_tij_entry.web_list;
          this.$refs.radnoVrijeme.$data.value = prav_tij_entry.radno_vrijeme == null ? '': prav_tij_entry.radno_vrijeme;
          this.$refs.opis.$data.value = prav_tij_entry.opis == null ? '' : prav_tij_entry.opis;
          if (prav_tij_entry.institucija != null) {
            this.$refs.nadleznaInst.$data.results_final.uid =prav_tij_entry.institucija.uid;
            this.$refs.nadleznaInst.$data.results_final.name = prav_tij_entry.institucija.naziv
          }
          this.$emit("finished");
        });
    }
  },
  mounted() {
    this.pravnoTijelo.ime = this.$refs.imeFiz.$data;
    this.pravnoTijelo.prezime = this.$refs.prezimeFiz.$data;

    this.pravnoTijelo.adrese_list = this.$refs.adresaElement.$data;

    this.pravnoTijelo.email_list = this.$refs.email.$data;
    this.pravnoTijelo.tel_br_list = this.$refs.telefon.$data;
    this.pravnoTijelo.web_list = this.$refs.stranica.$data;
    this.pravnoTijelo.institucija = this.$refs.nadleznaInst.$data;
    this.pravnoTijelo.radno_vrijeme = this.$refs.radnoVrijeme.$data;
    this.pravnoTijelo.opis = this.$refs.opis.$data;
    console.log(this.pravnoTijelo)
    
  },
  props: ["institucije","invalid_elements"],
  components: {
    "form-input": formInput,
    "form-textarea": formTextarea,
    "form-drop-down": formDropDown,
    "form-autocomplete": formAutocomplete,
    "adresa-element":adresaElement,
    "form-input-multiple":formInputMultiple,
    "form-autocomplete-single": formAutocompleteSingle,
  },
};
</script>
